export default [
  'build.after',
  'build.before',
  'mount.after',
  'mount.before',
  'move.after',
  'move',
  'pause',
  'play',
  'resize',
  'run.after',
  'run.before',
  'run.end',
  'run.offset',
  'run.start',
  'run',
  'swipe.end',
  'swipe.move',
  'swipe.start',
  'translate.jump',
  'update'
]
